<template>
  <div>
    <div id="top-bar-line" class="light-blue d-none d-lg-block"></div>
    <div id="top-bar" class="d-none d-sm-block blue">
      <div class="container no-pad-both">
        <div id="top-bar-logo-small"><router-link to="/explore"><img src="@/assets/img/web_logo_knud.png" class="logo-small" alt="Odense Rundt logo" aria-label="Gå til forsiden"/></router-link></div>
        <nav id="top-bar-nav" class="float-right" aria-label="Indholds menu">
          <ul class="nav-ul">
            <li><router-link to="/explore"><span>Odense Rundt</span></router-link></li>
            <li><router-link to="/directions"><span>Ruteplanlægger</span></router-link></li>
            <li><router-link to="/search"><span>Søg</span></router-link></li>
            <li><router-link to="/contact"><span>Kontakt</span></router-link></li>
            <li><router-link to="/help"><span>Hjælp</span></router-link></li>
            <li><router-link to="/news"><span>Nyt</span></router-link></li>
            <li class="profile profile-link-btn"><router-link to="/profile"><span>Profil</span></router-link></li>
            <li class="logout profile-logout-btn pointer" v-if="loggedIn" @click="Profile.logout()" tabindex="0">Log ud</li>
          </ul>
        </nav>
      </div>
    </div>

    <div id="mobile-top-bar" class="d-block d-sm-none blue">
    	<div id="mobile-back-btn" onclick="javascript:history.go(-1)" role="button" aria-label="Gå tilbage"><span class="material-icons" aria-hidden="true">chevron_left</span></div>
    	<div id="mobile-page-title"><h1 aria-live="polite" id="mobile-page-title-text">Overskrift</h1></div>
    	<router-link to="/search">
        <div id="mobile-search-btn" class="mobile-top-bar-btn" role="button" aria-label="Søg i Odense Rundt">
          <span class="material-icons" aria-hidden="true">search</span>
          <span class="btn-text" >Søg</span>
        </div>
      </router-link>
      <div id="mobile-menu-toggle" class="mobile-top-bar-btn" role="button" @click="toggleMenu();">
        <span class="material-icons" aria-hidden="true">menu</span>
        <span class="btn-text" aria-label="Åben menu">Menu</span>
      </div>
    </div>

    <nav id="mobile-menu" class="hidden" aria-label="Mobile indholds menu">
			<ul id="mobile-menu-list">
				<li id="close-menu-btn" class="hidden" role="button" aria-label="Gå tilbage til indhold" @click="backToContent();"></li>
				<li>
          <router-link to="/explore" aria-label="Forside">
            <span class="material-icons grey-text" aria-hidden="true">home</span>
            <span>Startside</span>
          </router-link>
        </li>
				<li>
          <router-link to="/news" aria-label="Nyt">
            <span class="material-icons grey-text" aria-hidden="true">notifications</span>
            <span>Nyt</span>
          </router-link>
        </li>
				<li>
          <router-link to="/profile" aria-label="Profil">
            <span id="mobile-profile-anchor" class="material-icons grey-text" aria-hidden="true">person_pin</span>
            <span>Profil</span>
          </router-link>
        </li>
				<li>
          <router-link to="/recommended">
            <span id="mobile-recommended-anchor" class="material-icons grey-text" aria-hidden="true">thumb_up</span>
            <span>Forslag</span>
          </router-link>
        </li>
				<li>
          <router-link to="/explore">
            <span id="mobile-themes-anchor" class="material-icons grey-text" aria-hidden="true">dashboard</span>
            <span>Temaer</span>
          </router-link>
        </li>
				<li>
          <router-link to="/alphabetic">
            <span id="mobile-alphabetic-anchor" class="material-icons grey-text" aria-hidden="true">list</span>
            <span>A-Å</span>
          </router-link>
        </li>
				<li>
          <router-link to="/directions">
            <span id="mobile-routeplanner-anchor" class="material-icons grey-text" aria-hidden="true">directions</span>
            <span>Ruteplanlægger</span>
          </router-link>
        </li>
				<li>
          <router-link to="/contact">
            <span id="mobile-contact-anchor" class="material-icons grey-text" aria-hidden="true">mail</span>
            <span>Kontakt os</span>
          </router-link>
        </li>
				<li>
          <router-link to="/help" aria-label="Hjælp til Odense Rundt">
            <span id="mobile-help-anchor" class="material-icons grey-text" aria-hidden="true">help</span>
            <span>Hjælp</span>
          </router-link>
        </li>
				<li>
          <router-link to="/about">
            <span id="mobile-about-anchor" class="material-icons grey-text" aria-hidden="true">info</span>
            <span>Om Odense Rundt</span>
          </router-link>
        </li>
				<li v-if="loggedIn" @click="Profile.logout()" tabindex="0" role="button">
          <span class="material-icons grey-text" aria-hidden="true">lock</span>
          <span>Log ud</span>
        </li>
			</ul>
    </nav>
  </div>
</template>

<script>
import Profile from '@/assets/profile/Profile.js'
import { EventBus } from '@/main.js'

export default {
  data() {
    return {
      loggedIn: false,
    }
  },
  created() {
    this.Profile = Profile;
    EventBus.$on('loggedIn', () => {
  		this.checkIfLoggedIn();
    });
    this.checkIfLoggedIn();
  },
  methods: {
    checkIfLoggedIn() {
      this.loggedIn = Profile.loggedIn;
    },
    toggleMenu() {
      if(document.getElementById('content').classList.contains('menu-open')) {
        document.getElementById('content').classList.remove('menu-open');
        document.getElementById('mobile-menu').classList.remove('menu-open');
        setTimeout(() => {
          document.getElementById('mobile-menu').classList.add('hidden');
        }, 200);
      }
      else {
        document.getElementById('mobile-menu').classList.remove('hidden');
        setTimeout(() => {
          document.getElementById('content').classList.add('menu-open');
          document.getElementById('mobile-menu').classList.add('menu-open');
        }, 50);
      }
    },
    backToContent() {
      this.toggleMenu();
      this.$HelperFunctions.setScreenReaderFocus();
    }
  }
}
</script>

<style lang="scss" scoped>
/*Top bar - PC / Tablet - Shown on above XS*/
#top-bar {
  position: fixed;
  z-index: 997;
  top: 10px;
  left: 0;
  width: 100%;
  height: 40px;
}

#top-bar-nav {
  display: inline-block;
  width: auto;
  height: 100%;
  padding-left: 10px;
  vertical-align: middle;
}

.nav-ul {
  height: 100%;
  margin: 0;
  line-height: 40px;
}

.nav-ul li {
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  height: 100%;
  margin-right: 20px;
}

.nav-ul a {
  color: #f8f8f8;
}

.nav-ul a.router-link-active li span {
  border-bottom: 2px solid #eee;
  color: #f8f8f8 !important;
  text-decoration: none;
}

/*Landscape - SM*/
@media screen and (min-width: 768px) and (max-width: 991px) and (orientation: landscape) {
  #top-bar {
    top: 0;
    height: 50px;
  }
  .nav-ul {
    line-height: 50px;
  }
}
/*Landscape - MD*/
@media screen and (min-width: 992px) and (max-width: 1199px) and (orientation: landscape) {
  #top-bar {
    top: 0;
  }
}

/*Portrait - SM*/
@media screen and (min-width: 768px) and (max-width: 1199px) and (orientation: portrait) {
  #top-bar {
    top: 0;
  }
}
/*Portrait - LG*/
@media screen and (min-width: 1200px) and (orientation: portrait) {
  #top-bar {
    height: 50px;
  }
}

#top-bar-line {
  position: fixed;
  z-index: 997;
  left: 0;
  top: 0;
  width: 100%;
  height: 10px;
}

#top-bar-logo-small {
  position: relative;
  display: inline-block;
  left: 10px;
  top: 0;
  width: auto;
  height: 100%;
}

.logo-small {
  position: relative;
  height: 30px;
  margin-top: 5px;
}

/*Mobile top bar - Only shown on XS*/
#mobile-menu {
	border-left: 1px solid #ddd;
	background-color: #f8f8f8;
  position: fixed;
  z-index: 1001;
  top: 50px;
  right: -250px;
  width: 250px;
  height: 100%;
  -moz-transition:all 200ms ease-in;
  -webkit-transition:all 200ms ease-in;
  -o-transition:all 200ms ease-in;
  transition:all 200ms ease-in;
}

@media screen and (min-width: 768px) {
  #mobile-menu {
    display: none;
  }
}

#mobile-menu.menu-open {
  right: 0px;
}

#mobile-top-bar {
	position: fixed;
	z-index: 997;
	height: 50px;
	width: 100%;
	top: 0;
	left: 0;
	border-bottom: 1px solid rgba(0,152,206,0.5);
	box-shadow: 0 2px 3px rgba(0,0,0,0.1);
}

.mobile-top-bar-btn {
	/*line-height: 50px;*/
	vertical-align: middle;
	width: 40px;
	height: 50px;
	font-size: 25px;
	text-align: center;
}

#mobile-menu-toggle {
	position: absolute;
	top: 0;
	right: 0;
}

#mobile-menu-toggle .btn-text {
	right: 7px;
}

#mobile-search-btn {
	position: absolute;
	top: 0;
	right: 50px;
}

#mobile-search-btn .btn-text {
	right: 11px;
}

#mobile-back-btn .material-icons, .mobile-top-bar-btn .material-icons {
	height: 40px;
	line-height: 40px;
  color: #f8f8f8;
}

.mobile-top-bar-btn .btn-text {
	font-size: 12px;
	position: absolute;
	bottom: 0px;
	color: #f8f8f8;
}

#mobile-page-title {
  position: absolute;
	display: table;
	left: 50%;
	margin-left: -85px;
	width: 170px;
	height: 100%;
	font-size: 15px;
  text-align: center;
	/*overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis*/
}

@media screen and (min-width: 375px) and (max-width: 768px) {
	#mobile-page-title {
		margin-left: -100px;
		width: 200px;
	}
}

#mobile-page-title-text {
	display: table-cell;
  vertical-align: middle;
	line-height: 20px;
  font-size: 15px;
}

#mobile-back-btn {
  position: absolute;
  display: inline-block;
  height: 100%;
	left: 0%;
	top: 5px;
}

/* Mobile menu */
#mobile-menu-list li {
	width: 100%;
	height: 40px;
	border-bottom: 1px solid rgba(221,221,221,0.3);
	padding: 5px 0px 5px 10px;
	font-weight: 550;
	color: rgb(000, 112, 141);
}

#mobile-menu-list li span {
	display: table-cell;
	vertical-align: middle;
	padding-left:10px;
}

#mobile-menu-list span.material-icons {
  height: 30px;
  width: 30px;
  line-height: 30px;
  display: table-cell;
}
</style>
